import React, { useState } from 'react';
import { MdArrowBack } from 'react-icons/md';

const ChangePasswordScreen = ({ currentUser, forced, loading, error, done, onSubmit, onBack }) => {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({ currentPassword, newPassword, confirmPassword });
  };

  return (
    <div className="screen change-password-screen bh-flow">
      <header className="bh-flow-hero">
        <div className="bh-flow-hero-left">
          {!forced && (
            <button className="bh-flow-back" onClick={onBack} aria-label="Back">
              <MdArrowBack />
            </button>
          )}
          <h1 className="bh-flow-title">{forced ? 'Set a new password' : 'Change password'}</h1>
        </div>
      </header>

      <div className="bh-flow-body">
        <p className="cp-subtitle">Signed in as {currentUser}.</p>

        {forced && !done && (
          <div className="login-notice" role="status">
            You signed in with a temporary password. Choose your own to continue.
          </div>
        )}

        {done ? (
          <>
            <div className="login-notice" role="status">Password updated. Use it next time you sign in.</div>
            <button className="bh-btn-primary" type="button" onClick={onBack}>Done</button>
          </>
        ) : (
          <form onSubmit={handleSubmit} noValidate>
            <label htmlFor="cp-currentPassword">Current password</label>
            <input className="bh-input" type="password" id="cp-currentPassword" name="currentPassword" autoComplete="current-password" placeholder="Current password" value={currentPassword} onChange={e => setCurrentPassword(e.target.value)} />

            <label htmlFor="cp-newPassword">New password</label>
            <input className="bh-input" type="password" id="cp-newPassword" name="newPassword" autoComplete="new-password" placeholder="At least 6 characters" value={newPassword} onChange={e => setNewPassword(e.target.value)} />

            <label htmlFor="cp-confirmPassword">Confirm new password</label>
            <input className="bh-input" type="password" id="cp-confirmPassword" name="confirmPassword" autoComplete="new-password" placeholder="Re-enter new password" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} />

            {error && <div className="login-error" role="alert">{error}</div>}

            <button className="bh-btn-primary" type="submit" disabled={loading}>
              {loading ? 'Updating…' : 'Update password'}
            </button>

            {!forced && (
              <button className="bh-btn-secondary" type="button" onClick={onBack}>Cancel</button>
            )}
          </form>
        )}
      </div>
    </div>
  );
};

export default ChangePasswordScreen;
